var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0066 15.5428C11.7996 15.5428 7.84828 11.6841 7.84828 5.49492C7.84828 4.15711 8.15414 2.34538 8.58445 1.39382C8.71312 1.09476 8.75765 0.888511 8.75765 0.72492C8.75765 0.362109 8.49374 0 8.00718 0C7.84453 0 7.54851 0.0435934 7.26328 0.149999C2.90836 1.89703 0 6.51047 0 11.4016C0 18.2796 5.20781 23.212 12.0645 23.212C17.0562 23.212 21.402 20.2041 22.9289 16.3078C23.0534 16.0003 23.0916 15.6938 23.0916 15.5461C23.0916 15.0872 22.7325 14.7795 22.3643 14.7795C22.1698 14.7795 21.986 14.8315 21.7149 14.9356C20.8441 15.2412 19.4163 15.5428 18.0066 15.5428Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.cc2d6724082358f7f0bfaad011ecc235.svg";
export { ForwardRef as ReactComponent };